var _rect, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmazon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    x: 0.5,
    y: 0.5,
    fill: "#181818",
    rx: 19.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f90",
    d: "M28.137 27.924c-2.205 1.628-5.403 2.494-8.157 2.494-3.859 0-7.334-1.427-9.964-3.8-.207-.187-.023-.442.226-.298 2.837 1.652 6.346 2.646 9.97 2.646 2.445 0 5.132-.507 7.605-1.556.373-.159.685.245.32.514"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f90",
    d: "M29.055 26.877c-.282-.36-1.865-.171-2.576-.086-.215.025-.248-.163-.054-.299 1.261-.886 3.331-.63 3.571-.334.243.3-.063 2.373-1.246 3.364-.183.152-.355.07-.275-.13.266-.665.863-2.154.58-2.515"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.586 18.68c0 1.11.027 2.035-.533 3.022-.453.802-1.173 1.295-1.973 1.295-1.092 0-1.732-.832-1.732-2.066 0-2.427 2.177-2.868 4.238-2.868zm2.873 6.947a.59.59 0 0 1-.674.066c-.946-.787-1.116-1.15-1.633-1.899-1.564 1.593-2.672 2.072-4.697 2.072-2.4 0-4.265-1.48-4.265-4.44 0-2.314 1.253-3.886 3.038-4.658 1.546-.678 3.705-.801 5.358-.987v-.37c0-.679.053-1.48-.346-2.067-.346-.524-1.013-.74-1.6-.74-1.086 0-2.052.557-2.29 1.711-.049.257-.236.51-.495.524l-2.761-.3c-.234-.052-.493-.239-.425-.595.634-3.35 3.66-4.362 6.37-4.362 1.387 0 3.2.37 4.292 1.419 1.386 1.295 1.253 3.022 1.253 4.903v4.44c0 1.335.554 1.92 1.075 2.64.182.26.223.567-.009.757-.582.488-1.616 1.386-2.185 1.892z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    x: 0.5,
    y: 0.5,
    stroke: "#d4ebfd",
    rx: 19.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.926 9.582h20.148v20.836H9.926z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazon);
export default __webpack_public_path__ + "static/media/amazon.5f5734ba6da5817a7ecb5248450a5a07.svg";
export { ForwardRef as ReactComponent };